import { getCurrentUser } from "./auth";

export interface Route {
  path: string;
  render: () => string;
  onMount?: () => void;
  requiresAuth?: boolean;
}

let routes: Route[] = [];
let notFoundRoute: Route | null = null;

export function registerRoutes(routeList: Route[]): void {
  routes = routeList;
}

export function setNotFoundRoute(route: Route): void {
  notFoundRoute = route;
}

export function navigate(path: string): void {
  window.location.hash = path;
}

export function getHash(): string {
  return window.location.hash.replace(/\?.*$/, "") || "#/";
}

export function getQueryParams(): Record<string, string> {
  const hash = window.location.hash;
  const queryIndex = hash.indexOf("?");
  if (queryIndex === -1) return {};
  const params = new URLSearchParams(hash.substring(queryIndex + 1));
  const result: Record<string, string> = {};
  params.forEach((value, key) => {
    result[key] = value;
  });
  return result;
}

export function startRouter(): void {
  window.addEventListener("hashchange", handleRoute);
  handleRoute();
}

function handleRoute(): void {
  const hash = getHash();
  const path = hash.startsWith("#") ? hash.substring(1) : hash;

  let route = routes.find((r) => r.path === path);

  if (!route && notFoundRoute) {
    route = notFoundRoute;
  }

  if (!route) return;

  // Auth guard
  if (route.requiresAuth && !getCurrentUser()) {
    navigate("#/login");
    return;
  }

  // If user is logged in and tries to access login/signup, redirect to dashboard
  if ((path === "/login" || path === "/signup") && getCurrentUser()) {
    navigate("#/dashboard");
    return;
  }

  const app = document.getElementById("app");
  if (app) {
    app.innerHTML = route.render();
    if (route.onMount) {
      route.onMount();
    }
  }
}

export function refreshRoute(): void {
  handleRoute();
}
